import {
  APPLICATION,
  CAMPAIGN,
  ATTACHMENT,
  PRODUCT,
  PAGE,
  SHORT_LINK,
  COUPON,
  SALE,
  TAX_RATE
} from "utils/constants/models";
import kebabCase from "lodash/kebabCase";

const APPLICATION_UUID = `${APPLICATION}-uuid`;
const PRODUCT_UUID = `${PRODUCT}-uuid`;
const PAGE_UUID = `${PAGE}-uuid`;
const SHORT_LINK_UUID = `${kebabCase(SHORT_LINK)}-uuid`;
const COUPON_UUID = `${COUPON}-uuid`;
const SALE_UUID = `${SALE}-uuid`;
const ATTACHMENT_UUID = `${ATTACHMENT}-uuid`;
const CAMPAIGN_UUID = `${CAMPAIGN}-uuid`;
const TAX_RATE_UUID = `${kebabCase(TAX_RATE)}-uuid`;

export const QUERY_PARAM_KEY = {
  APPLICATION_UUID,
  ATTACHMENT_UUID,
  CAMPAIGN_UUID,
  PRODUCT_UUID,
  PAGE_UUID,
  SHORT_LINK_UUID,
  COUPON_UUID,
  SALE_UUID,
  TAX_RATE_UUID
};
